module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/09-f0a29d27055cc43fcf462961cebe55db.png";